/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/antisthlm/"

// Shared style definitions
const sectionTitleStyle =
  "font-['HelveticaNeue-Medium'] text-[28px] !text-[#3A3A3A] tracking-[0.02em] leading-[1]"
const itemTitleStyle =
  "font-['HelveticaNeue-Medium'] text-[16px] !text-[#3A3A3A] tracking-[-0.02em] leading-[1.1]"
const itemSubtitleStyle = "font-['HelveticaNeue-Regular'] text-[13px] !text-[#3A3A3A]"

const antisthlm: CommunityData = {
  code: "antisthlm",
  inviteCode: "antisthlm",
  name: "ANTI STHLM",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/ant-080`,
  socials: {},
  styles: {
    global: {
      werzLogoColor: "#000000",
      counterColor: "#3A3A3A",
      alternativeLogo: {
        src: `${S3_PREFIX}logo-web.png`,
        styles: "w-[220px] !-bottom-5",
      },
      logo: {
        src: `${S3_PREFIX}logo-web.png`,
        styles: "w-[220px]",
      },
      modalWindow: {
        container: "bg-[#FEFEF9]",
        title: "",
        subtitle: "",
      },
      bgColor: "#EDEDED",
      asideBg: "#EDEDED",
      asideStyles: "#EDEDED",
      contentBg: "#EDEDED",
      contentBoxShadow: "",
      nonMemberBg: "",
      bgDesktop: "",
      bgMobile: "",
      mainFont: "font-['HelveticaNeue-Regular'] !text-[#3A3A3A]",
      primaryButton:
        "bg-[#3A3A3A] !text-[#FFF] px-6 py-4 rounded-none border border-[#3A3A3A] font-['HelveticaNeue-Medium'] text-[22px]",
    },
    navigation: {
      iconsColor: "#EDEDED",
      sideBarSeparator: "#EDEDED",
      separator: "#EDEDED",
      item: "font-['HelveticaNeue-Medium'] text-[16px] text-[#3A3A3A] uppercase opacity-50 text-center",
      itemSelected: "!opacity-100",
    },
    communityLanding: {
      container: "!p-0 !m-0 border-none rounded-none",
      titles: sectionTitleStyle,
      emptyOrLoadingState: `!mx-4 sm:!mx-8 ${itemSubtitleStyle}`,
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 hidden",
        sectionTitle: `${sectionTitleStyle} pl-4 sm:pl-8 !mb-4 sm:mb-6`,
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] h-full overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover rounded-none",
          placeholderMedia: "w-full h-full bg-gray-400 rounded-none",
          content: "flex flex-col py-4 bg-transparent",
          title: itemTitleStyle,
          subtitle: `${itemSubtitleStyle} mt-2`,
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle: `${sectionTitleStyle} pl-4 sm:pl-8 !mb-4 sm:mb-6`,
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden",
          mediaContainer: "w-full sm:!w-[228px] h-[128px] sm:!h-[128px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover rounded-none",
          placeholderMedia: "w-full h-full bg-gray-400 rounded-none",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent",
          title: itemTitleStyle,
          subtitle: `${itemSubtitleStyle} mt-2`,
          location: `${itemSubtitleStyle} mt-2`,
          date: `${itemSubtitleStyle} mt-2`,
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: sectionTitleStyle,
        text: itemSubtitleStyle,
        customShopImage: "",
        customShopImageStyle: "!rounded-none !border-0 bg-gray-400",
        sectionTitle: `${sectionTitleStyle} !mb-4 !sm:mb-6`,
      },
    },
    eventV2: {
      container: "flex flex-col border-none rounded-none",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 rounded-none !border-0",
        title: sectionTitleStyle,
        subtitle: `${itemSubtitleStyle} mb-4`,
        button: "!w-fit mb-4 sm:mb-0 rounded-none",
        questions: itemSubtitleStyle,
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: sectionTitleStyle,
        text: `${itemSubtitleStyle} mb-4 w-full`,
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: sectionTitleStyle,
        text: `${itemSubtitleStyle} mb-4 max-w-[652px] w-full !text-[#3A3A3A]`,
        map: "w-full h-[206px] overflow-hidden rounded-none border border-[#3A3A3A80]",
        mapPinColor: "#3A3A3A",
        mapStrokeColor: "#000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: sectionTitleStyle,
        text: itemSubtitleStyle,
      },
      tickets: {
        header: sectionTitleStyle,
        outerContainer: "flex flex-col sm:p-8 p-4",
        innerContainer: "flex flex-col mt-4 rounded-none overflow-hidden",
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto py-4 border-b border-[#3A3A3A80]",
          media: "!hidden",
          name: "font-['HelveticaNeue-Medium'] text-[16px] text-[#3A3A3A] tracking-[-0.02em]",
          description: "font-['HelveticaNeue-Regular'] text-[13px] text-[#3A3A3A]",
          price: "font-['HelveticaNeue-Medium'] text-[16px] text-[#3A3A3A] tracking-[-0.02em]",
          quantity: "font-['HelveticaNeue-Regular'] text-[13px] text-[#3A3A3A]",
          status: "font-['HelveticaNeue-Medium'] text-[16px] text-[#3A3A3A] tracking-[-0.02em]",
          counterContainer:
            "bg-[#FFF] !w-fit font-['HelveticaNeue-Medium'] text-[13px] rounded-none border border-[#3A3A3A80]",
          button:
            "font-['HelveticaNeue-Medium'] text-[13px] py-2 px-3 bg-[#3A3A3A] !w-fit rounded-none border border-[#3A3A3A] text-[#FFF]",
          plusMinusColor: "#3A3A3A",
          descriptionCutoff: 27,
        },
      },
    },
  },
}

export default antisthlm
